import { render, staticRenderFns } from "./value-proposition.vue?vue&type=template&id=42f26e5c&scoped=true&"
import script from "./value-proposition.vue?vue&type=script&lang=js&"
export * from "./value-proposition.vue?vue&type=script&lang=js&"
import style0 from "./value-proposition.vue?vue&type=style&index=0&id=42f26e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f26e5c",
  null
  
)

export default component.exports